import { Node, mergeAttributes } from "@tiptap/core";

const SectionTitle = Node.create({
  name: "sectionTitle",

  content: "text*",

  marks: "",

  group: "block",

  defining: true,

  selectable: false,

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        const selectedNode = this.editor.state.selection.$head.node(
          this.editor.state.selection.$head.depth,
        );

        if (selectedNode.type.name === "sectionTitle") {
          const sections = this.editor.$doc.querySelectorAll("section");
          const firstSectionNode = sections[0];
          const sectionNode = this.editor.state.selection.$head.node(
            this.editor.state.selection.$head.depth - 1,
          );

          // If the cursor is at the beginning of the section title and it is not the first section
          if (
            this.editor.state.selection.head ===
              this.editor.state.selection.$head.posAtIndex(0) &&
            firstSectionNode &&
            !sectionNode?.eq(firstSectionNode.node)
          ) {
            const sectionIndex = sections.findIndex((section) =>
              sectionNode?.eq(section.node),
            );
            const previousSection = sections[sectionIndex - 1];

            this.editor
              .chain()
              .focus()
              .insertContentAt(
                // Need to make sure to subtract 2 so the position is inside the section
                previousSection.pos + previousSection.node.nodeSize - 2,
                {
                  type: "paragraph",
                },
              )
              .run();

            return true;
          }

          const textNode = selectedNode.child(0);

          if (
            this.editor.state.selection.head !==
            textNode.nodeSize + this.editor.state.selection.$head.posAtIndex(0)
          ) {
            return this.editor
              .chain()
              .focus(
                textNode.nodeSize +
                  this.editor.state.selection.$head.posAtIndex(0),
              )
              .createParagraphNear()
              .run();
          }
        }

        return false;
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "section.h2:first-child",
      },
      {
        tag: "sectionTitle",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [`h2`, mergeAttributes(HTMLAttributes), 0];
  },
});

export default SectionTitle;
